/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_EditInputs */

const vi_packaging_bom_edit = /** @type {(inputs: Packaging_Bom_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa định mức`)
};

/**

* @param {Packaging_Bom_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_edit = /** @type {((inputs?: Packaging_Bom_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_edit(inputs)
});